module.exports = __webpack_public_path__ + "img/gift.a3ac53d3.png";